<template>
  <div>
    <ul>
      <li>
        <p>公司名称：阜卫医考书店（考试宝典线下体验中心）</p>
        <p>
          网站名称：考试宝典（<a
            target="_black"
            href="https://hzs.ksbao.com/?ac=055618"
            >点击体验</a
          >）
        </p>
        <p>咨询电话：18505513002</p>
        <p>投诉电话：18019941066</p>
        <p>咨询时间：全天7*24小时（周六、周日节假日不休息）</p>
        <p>E-mail ：755811231@qq.com</p>
        <p>
          公司地址：安徽省阜合产业园安徽医科大学附属阜阳医院东门300米海亮悦府商业街
        </p>
        <div class="map">
          <MapKsb />
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import MapKsb from "../../../components/map/MapKsb";
export default {
  components: { MapKsb },
  setup() {
    return {};
  },
};
</script>

<style lang="less" scoped>
ul {
  //display: block;
  background: rgb(245, 245, 245);
  width: 580px;
  height: 950px;
  border-radius: 8px;
  margin-bottom: 20px;
  p {
    margin: 10px 15px 10px 15px;
    padding: 10px 10px 15px 10px;
    font-size: 16px;
    a {
      color: @shColor;
    }
  }
  .map {
    width: 580px;
    height: 518px;
  }
}
</style>
